import React from 'react';

const HomeWarranties = () => {
  return (
    <div>
      <h2 className="text-xl font-bold uppercase mt-8 mb-2 border-b pb-1">
        Home Warranties
      </h2>
      <ol className="text-black mb-4 text-base list-decimal list-inside text-bold">
        <li>
          At or before settlement, either party may purchase a home warranty for
          the Property from a third-party vendor. Buyer and Seller understand
          that a home warranty for the Property does not alter any disclosure
          requirements of Seller, will not cover or warrant any pre-existing
          defects of the Property, and will not alter, waive or extend any
          provisions of this Agreement regarding inspections or certifications
          that Buyer has elected or waived as part of this Agreement. Buyer and
          Seller understand that a broker who recommends a home warranty may
          have a business relationship with the home warranty company that
          provides a financial benefit to the broker
        </li>
      </ol>
    </div>
  );
};

export default HomeWarranties;
